<template>
  <v-app>
      <router-view></router-view>
  </v-app>
</template>

<script>
  export default {
    name: 'app',
    metaInfo: {
      title: 'Payroll Made Easy | Fast and Secure | Access From Anywhere, Any Device',
      titleTemplate: 'Payroll Made Easy | Fast and Secure | Access From Anywhere, Any Device',
      meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Cloud based, certified pre-filled BIR tax reports, custom compensation & benefits, one-click payroll and annualization processing, attendance management, self-service, approval worfklow & traceability, access permissions, finance tools, and project charges' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {},
    computed: {}
  }
</script>
